import {useState, useEffect, useContext} from "react";
import Modal from "react-modal";
import "../../assets/stylesheets/homeOpen.css";
import whatsappIcon from "../../assets/image/whatsapp.svg";
import messengerIcon from "../../assets/image/messenger.svg";
import phoneIcon from "../../assets/image/phone.svg";
import telegramIcon from "../../assets/image/telegram.svg";
import callIcon from "../../assets/image/call.svg";
import { useTranslation } from "react-i18next";
import axios from "axios";
import {ContactInfoContext} from "../additional/ContactInfoContext";
import {FaTimes} from "react-icons/fa";

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement("#root");

function HomeOpen() {
  const { t, i18n } = useTranslation(["home"]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const { contactInfo } = useContext(ContactInfoContext);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
      <div className="container">
        <div id="wrapper">
          <button
              className="btn__up"
              style={{ display: visible ? "block" : "none" }}
              onClick={scrollToTop}
          >
            <i className="fa fa-arrow-up"></i>
          </button>
          <div className="fixes__btn">
            <img src={callIcon} onClick={openModal} alt="call" />
          </div>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Contact Modal"
            overlayClassName="modal-overlay"
            className="modal-content"
        >
          <div className="modalArea">
            {/*<FaTimes*/}
            {/*    className="closeModal"*/}
            {/*    onClick={closeModal}*/}
            {/*/>*/}
            <div className="modal__content-info">
              <h2 className="modal__icon-h">{t("call")}</h2>
              <div className="modal__icon-items">
                {contactInfo.wpPhone && (
                    <a
                        href={`https://api.whatsapp.com/send?phone=${contactInfo.wpPhone}`}
                        className="modal__icon-item whatsapp"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                      <img src={whatsappIcon} alt="whatsapp" />
                      <span>WhatsApp</span>
                    </a>
                )}
                {contactInfo.tgUsername && (
                    <a
                        href={`https://t.me/${contactInfo.tgUsername}`}
                        target="_blank"
                        className="modal__icon-item telegram"
                        rel="noopener noreferrer"
                    >
                      <img src={telegramIcon} alt="telegram" />
                      <span>Telegram</span>
                    </a>
                )}
                {contactInfo.messenger && (
                    <a
                        href={contactInfo.messenger}
                        target="_blank"
                        className="modal__icon-item messenger"
                        rel="noopener noreferrer"
                    >
                      <img src={messengerIcon} alt="messenger" />
                      <span>Messenger</span>
                    </a>
                )}
                {contactInfo.telPhone && (
                    <a
                        href={`tel:${contactInfo.telPhone}`}
                        className="modal__icon-item phone"
                    >
                      <img src={phoneIcon} alt="phone" />
                      <span>Phone</span>
                    </a>
                )}
              </div>
            </div>
          </div>
        </Modal>
      </div>
  );
}

export default HomeOpen;